import { useL10n } from '@uplift/hooks';
import { TextInput } from '@uplift/ui-v2';
import { Form } from 'formik';

export const PronounsForm = () => {
  const l10n = useL10n();

  return (
    <Form>
      <TextInput
        autoFocus
        name="pronouns"
        label={l10n.accountSettings.isOptional(l10n.accountSettings.profile.pronouns)}
      />
    </Form>
  );
};
